import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import PrivacyPolicyContent from '../../components/Pages/PrivacyPolicy';
import FAQContent from '../../components/Pages/FAQ';

const { displayName } = config;

export default function FAQ(): React.ReactElement {
  document.title = `${displayName}: FAQ`;

  return (
    <Layout>
      <FAQContent />
    </Layout>
  );
}
